import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const SEO = ({ title, description }) => {
  const location = useLocation();

  useEffect(() => {
    document.title = title || 'Interventional Radiologist in Mumbai | Dr. Punit Mahajan';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', description || 'Dr. Punit Mahajan is a fellowship-trained Interventional Radiologist in Mumbai offering minimally invasive treatments.');
    }
  }, [title, description, location]);

  return null;
};
